// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".atom-image-title[data-v-521b6464]{background-position:50%;background-repeat:no-repeat;background-size:cover}.atom-image-title .background-gradient[data-v-521b6464]{background:rgba(0,0,0,.3);padding:4.875rem 3.75rem 2rem}@media only screen and (max-width:900px){.atom-image-title .background-gradient[data-v-521b6464]{padding:4.688rem 1.25rem 1.875rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
